export enum TimeZone {
  AMERICA_NEW_YORK = 'America/New_York'
}